import React from 'react';

import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

export interface DivisaoProps {
    idDivisao: number;
    dsDivisao: string;
    cdDivisao: number;
}

type DivisaoAutoCompleteProps = Pick<CissAutoCompleteProps, 'label' | 'value' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange' | 'size'>;

export function DivisaoAutoComplete({ value, error, label = 'Divisão', multiple = false, sx, onChange, size }: DivisaoAutoCompleteProps) {
    return (
        <CissAutoComplete
            size={size}
            label={label}
            value={value}
            multiple={multiple}
            error={error}
            objectId="idDivisao"
            selectedStringTemplate="{dsDivisao}"
            optionStringTemplate="{dsDivisao}"
            requestOptions={{
                url: '/gestao/divisao',
                sort: [{ property: 'dsDivisao', direction: 'ASC' }],
                columns: 'idDivisao,dsDivisao,cdDivisao',
                limit: 50,
            }}
            isOptionEqualToValue={(option: DivisaoProps, value: DivisaoProps) => option.idDivisao === value.idDivisao}
            onChange={onChange}
            sx={sx}
        />
    );
}
